export default __webpack_public_path__ + "static/N0029-4031ff2fdcc91fa50b052c48d2906f2e.png";